import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TenantService } from "projects/shared/src/lib/services/tenant.service";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridUsersSettings {

  constructor(private translate: TranslateService, private tenantService: TenantService, private deletable: boolean) { }

    getRowStyle = (params: any) => {
      const dueDate = new Date(_.get(params.data, 'invitationDueDate', ''));
      const today = new Date();
      
      const dueDateOnly = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      if (params.data && _.get(params.data, 'lockoutEnabled', '') === true || (_.get(params.data, 'emailConfirmed', '') === false 
                            /*&& _.get(params.data, 'invitationDueDate', '') != '0001-01-01T00:00:00'*/ && dueDateOnly < todayOnly)) {
          return { 'background-color': '#eba3aa', 'color': 'black' };
        }
          return { 'background-color': 'white', 'color': 'black' };
   };

    public agGridUsersSettings = {
      rowModelType: 'infinite',
      rowSelection: 'single',
      rowHeight: 55,
      enableRangeSelection: true,
      cacheBlockSize: 10000,
      cacheOverflowSize: 2,
      maxConcurrentDatasourceRequests: 1,
      paginationPageSize: 30,
      infiniteInitialRowCount: 0,
      getRowStyle: (params: any) => this.getRowStyle(params),
      columnDefs: [
        {
          headerName: `${this.translate.data["USERSUSERNAMECOLUMNHEADER"]}`,
          sortable: true,
          filter: true,
          field: 'userName',
          wrapText: true, autoHeight: true,
          cellStyle: { 'white-space': 'pre-wrap' },
          valueGetter: (params: any) => {
            console.log("-----------> Benutzername: ", params.data);
            const lastName = _.get(params.data, 'last_Name', '')?.trim();
            const userName = (lastName !== '(not confirmed)') ? _.get(params.data, 'first_Name', '') + ' ' + _.get(params.data, 'last_Name', '') : "(not confirmed)";
            //const userName = _.get(params.data, 'userName', '');
            if (_.get(params.data, 'lockoutEnabled', '') === true) {
              return userName + '\n - gesperrt -';
            } else if (_.get(params.data, 'emailConfirmed', '') === false /*&& _.get(params.data, 'invitationDueDate', '') != '0001-01-01T00:00:00'*/) {
              const dueDate = new Date(_.get(params.data, 'invitationDueDate', ''));
              const today = new Date();
              
              const dueDateOnly = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
              const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
              if (dueDateOnly < todayOnly) {
              return userName + '\n - Einladung abgelaufen seit ' + dueDateOnly.toLocaleDateString() + ' -';
              }
              else return userName;
            }
            else return userName;
          },
        },
        { field: 'email', headerName: `${this.translate.data["USERSEMAILCOLUMNHEADER"]}`, sortable: true, filter: true },
        {
          width: 500,
          headerName: `${this.translate.data["USERSACTIONSCOLUMNHEADER"]}`,
          cellRenderer: 'buttonRenderer',
          cellRendererParams: {
            icon_edit: 'edit',
            icon_view: 'visibility',
            icon_delete: (this.deletable) ? 'delete' : '',
            routerLinkEditUser: (params: ICellRendererParams) => `/user-profile/${_.get(params, 'data.id')}`,
            routerLinkViewUser: (params: ICellRendererParams) => `/${this.tenantService.currentTenantName}/manage-users/${_.get(params, 'data.id')}`
          },
        },
      ],
      defaultColDef: {
        flex: 1,
        resizable: true,
        minWidth: 100,
        editable: false
      }
    }

}